<template>
  <div class="sub-account-class sm-qu-padding">
    <CCard color="light">
      <CCardHeader>
        <div class="ch-header">
          <a target="_blank" style="color: #1675D4;" :href="getLa == 'tw' ? 'https://www.youtube.com/watch?v=cub4uijtJ2o' : 'https://www.youtube.com/watch?v=LyeUf0-MJec'">{{ $t('SubAccount.SubAccountTutorial') }}</a>
          <!-- <div style="width:100%">
                        <el-alert center :closable="false" :title="$t('VirtualCard.CardHolderPage.CardHolderListTip')" type="warning"></el-alert>
                    </div> -->
          <div>
            <el-button
              @click="openCreateSubAccountDialog"
              class="create-holder-btn"
              >{{ $t("SubAccount.CreateSubAccount") }}</el-button
            >
          </div>
        </div>
      </CCardHeader>
      <CCardBody>
        <el-table :data="items" style="width: 100%">
          <template slot="empty">
            <div style="margin: 3rem 0">
              <h2>
                No items
                <CIcon
                  name="cilBan"
                  style="color: #e53535; width: 30px; height: 30px"
                />
              </h2>
            </div>
          </template>
          <el-table-column
            align="center"
            prop="UserName"
            width="320px"
            :label="$t('SubAccount.Account')"
          >
          <template slot-scope="scope">
            <div class="subaccount-columnText-bold">{{ scope.row.UserName }} <i style="color: rgb(0,190,164);cursor:pointer" @click="getCopy(scope.row.UserName)" class="el-icon-document-copy"></i></div>
          </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="Tag"
            :label="$t('SubAccount.Tag')"
          >
          <template slot-scope="scope">
            
            <div class="tag-box">
              <div class="subaccount-columnText-bold">{{ scope.row.Tag }}</div>
              <div @click="showEditTagDialog(scope)">
                <i
                  style="color: #00bea4; cursor: pointer"
                  class="el-icon-edit-outline"
                ></i>
              </div>
            </div>
          </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="AccountBalance"
            :label="$t('SubAccount.AccountBalance')"
          >
            <template slot-scope="scope">
              <div class="subaccount-columnText-bold">${{ scope.row.AccountBalance }}</div>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="CardBalance"
            :label="$t('SubAccount.CardBalance')"
          >
            <template slot-scope="scope">
              <div class="subaccount-columnText-bold">${{ scope.row.CardBalance }}</div>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="CardSpent"
            :label="$t('SubAccount.Spent')"
          >
            <template slot-scope="scope">
              <div class="subaccount-columnText-bold">${{ scope.row.CardSpent }}</div>
            </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="CardNum"
            :label="$t('SubAccount.ActiveCards')"
          >
          <template slot-scope="scope">
              <div class="subaccount-columnText-bold">{{ scope.row.CardNum }}</div>
          </template>
          </el-table-column>
          <el-table-column
            align="center"
            prop="Status"
            :label="$t('SubAccount.Status')"
          >
            <template slot-scope="scope">
              <div>
                <el-tag
                  size="small"
                  effect="dark"
                  :type="customStatusType(scope.row)"
                  >{{ scope.row.Status }}</el-tag
                >
              </div>
            </template>
          </el-table-column>
          <el-table-column align="center" :label="$t('SubAccount.Operation')">
            <template slot-scope="scope">
              <div>
                <!-- <el-button v-if="!useSelect" @click="handleRemoveCardHolder(scope.row)" size="small" type="danger">{{ $t('VirtualCard.CardHolderPage.Remove') }}</el-button>
                                <el-button v-else class="create-holder-btn" @click="handleSelectCardHolder(scope.row)" size="small">{{ $t('VirtualCard.Create.CardHolderSelect') }}</el-button> -->
                <el-dropdown
                  size="small"
                  @command="handleCommand($event, scope.row)"
                >
                  <CButton color="primary" variant="ghost" size="small">
                    <i class="el-icon-more"></i>
                  </CButton>
                  <!-- <i class="el-icon-more"></i> -->
                  <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item command="recharge">{{
                      $t("SubAccount.Recharge")
                    }}</el-dropdown-item>
                    <el-dropdown-item command="refund">{{
                      $t("SubAccount.Refund")
                    }}</el-dropdown-item>
                    <el-dropdown-item
                      v-if="scope.row.Status === 'Active'"
                      command="suspend"
                      >{{ $t("SubAccount.Suspend") }}</el-dropdown-item
                    >
                    <el-dropdown-item
                      v-if="scope.row.Status === 'Suspended'"
                      command="active"
                      >{{ $t("SubAccount.Active") }}</el-dropdown-item
                    >
                    <el-dropdown-item command="reset_password">{{
                      $t("SubAccount.SubAccountResetPassword")
                    }}</el-dropdown-item>
                  </el-dropdown-menu>
                </el-dropdown>
                <el-divider direction="vertical"></el-divider>
                <CButton
                  @click="lookDetail(scope.row, scope.$index)"
                  color="primary"
                  variant="ghost"
                  ><i class="el-icon-s-data"></i
                ></CButton>
              </div>
            </template>
          </el-table-column>
        </el-table>
      </CCardBody>
      <CCardFooter>
        <el-pagination
          background
          layout="prev, pager, next"
          :total="page_total"
          :page-sizes="[10, 20, 30, 40]"
          :page-size="page_size"
          @current-change="handerPage"
          @size-change="handleSizeChange"
        >
        </el-pagination>
      </CCardFooter>
    </CCard>
    <!-- 创建子账户窗口 -->
    <el-dialog
      append-to-body
      :close-on-click-modal="false"
      custom-class="create-card-holder-dialog"
      width="30%"
      :title="$t('SubAccount.CreateSubAccount')"
      :visible.sync="dialogFormVisible"
    >
      <div style="margin-bottom: 10px">
        <el-alert type="warning" :closable="false" show-icon>
          <div slot="title">
            <p class="create-sub-account-tip">
              {{ $t("SubAccount.SubAccountDesc1") }}
            </p>
            <p class="create-sub-account-tip">
              {{ $t("SubAccount.SubAccountDesc2") }}
            </p>
            <p class="create-sub-account-tip">
              {{ $t("SubAccount.SubAccountDesc3") }}
            </p>
            <p class="create-sub-account-tip">
              {{ $t("SubAccount.SubAccountDesc4") }}
            </p>
          </div>
        </el-alert>
      </div>
      <div
        style="
          margin-bottom: 20px;
          border-bottom: 1px solid #eee;
          padding-bottom: 10px;
        "
      >
        <div
          style="
            display: flex;
            justify-content: space-between;
            align-items: center;
          "
        >
          <div style="font-weight: bold">
            {{ $t("SubAccount.RemainingLimit") }}
          </div>
          <div style="font-weight: bold; font-size: 16px">
            {{ remain_sub_num }}
          </div>
        </div>
      </div>
      <el-form
        :model="subAccountForm"
        :rules="subAccountRulesForm"
        ref="ruleSubAccountForm"
        class="row g-3 demo-ruleForm"
      >
        <CCol md="12">
          <el-form-item
            required
            :label="$t('SubAccount.SubAccountEmail')"
            prop="email"
          >
            <el-input v-model="subAccountForm.email">
              <span slot="suffix">
                <el-tooltip
                  class="item"
                  effect="dark"
                  :content="$t('SubAccount.SubAccountEmailTip')"
                  placement="top"
                >
                  <i
                    style="
                      color: #e6a23c;
                      font-size: 18px;
                      vertical-align: -2px;
                      cursor: pointer;
                    "
                    class="el-icon-question el-input__icon"
                  ></i>
                </el-tooltip>
              </span>
            </el-input>
            <!-- <p style="margin:0;font-size:11px;font-weight:bold;line-height:1.5;">{{ $t('VirtualCard.CardHolderPage.StateTipMessage') }}</p> -->
          </el-form-item>
        </CCol>
        <CCol md="12">
          <el-form-item :label="$t('SubAccount.SubAccountTag')" prop="tag">
            <el-input v-model="subAccountForm.tag"></el-input>
          </el-form-item>
        </CCol>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelCreate('ruleSubAccountForm')">{{
          $t("SubAccount.Cancel")
        }}</el-button>
        <el-button
          class="create-holder-btn"
          @click="submitCardHolderForm('ruleSubAccountForm')"
          >{{ $t("SubAccount.Create") }}</el-button
        >
      </div>
    </el-dialog>
    <!-- 转入资金窗口 -->
    <el-dialog
      append-to-body
      :close-on-click-modal="false"
      custom-class="create-card-holder-dialog"
      width="30%"
      :title="
        isRecharge
          ? $t('SubAccount.RechargeSubAccount')
          : $t('SubAccount.SubAccountRefund')
      "
      :visible.sync="dialogReChargeVisible"
    >
      <div>
        <div
          style="
            margin-bottom: 20px;
            border-bottom: 1px solid #eee;
            padding-bottom: 10px;
          "
        >
          <div
            style="
              display: flex;
              justify-content: space-between;
              align-items: center;
            "
          >
            <div style="font-weight: bold">
              {{ $t("SubAccount.TargetSubAccount") }}
            </div>
            <div style="font-weight: bold; font-size: 16px">
              {{ sUserName }}
            </div>
          </div>
        </div>
        <el-form
          :model="subAccountRechargeForm"
          :rules="subAccountRechargeRulesForm"
          ref="ruleRechargeForm"
          class="row g-3 demo-ruleForm"
        >
          <CCol md="12">
            <el-form-item
              required
              :label="
                isRecharge
                  ? $t('SubAccount.RechargeAmount')
                  : $t('SubAccount.RefundAmount')
              "
              prop="recharge_amount"
            >
              <el-input
                v-model="subAccountRechargeForm.recharge_amount"
              ></el-input>
              <!-- <p style="margin:0;font-size:11px;font-weight:bold;line-height:1.5;">{{ $t('VirtualCard.CardHolderPage.StateTipMessage') }}</p> -->
            </el-form-item>
          </CCol>
        </el-form>
        <div slot="footer" class="dialog-footer recharge-dialog">
          <el-button @click="cancelRecharge('ruleRechargeForm')">{{
            $t("SubAccount.Cancel")
          }}</el-button>
          <el-button
            class="create-holder-btn"
            @click="submitRechargeForm('ruleRechargeForm')"
            >{{ $t("SubAccount.Submit") }}</el-button
          >
        </div>
      </div>
    </el-dialog>
    <!-- 确认冻结窗口 -->
    <el-dialog
      append-to-body
      :close-on-click-modal="false"
      custom-class="create-card-holder-dialog"
      width="30%"
      :title="customSuspendAndActiveTip()"
      :visible.sync="dialogSuspendVisible"
    >
      <div>
        <div
          style="
            margin-bottom: 20px;
            border-bottom: 1px solid #eee;
            padding-bottom: 10px;
          "
        >
          <div
            style="
              display: flex;
              justify-content: space-between;
              align-items: center;
            "
          >
            <div style="font-weight: bold">
              {{ $t("SubAccount.TargetSubAccount") }}
            </div>
            <div style="font-weight: bold; font-size: 16px">
              {{ sUserName }}
            </div>
          </div>
        </div>
      </div>
      <div slot="footer" class="dialog-footer recharge-dialog">
        <!-- <el-button @click="cancelRecharge('ruleRechargeForm')">{{$t('SubAccount.Cancel')}}</el-button> -->
        <el-button
          v-if="clickCommand === 'suspend'"
          class="create-holder-btn"
          @click="submitSuspend(0)"
          >{{ $t("SubAccount.Submit") }}</el-button
        >
        <el-button
          v-if="clickCommand === 'active'"
          class="create-holder-btn"
          @click="submitSuspend(1)"
          >{{ $t("SubAccount.Submit") }}</el-button
        >
      </div>
    </el-dialog>
    <!-- 详情窗口 -->
    <div v-if="staticInfoData != null">
      <CModal
        :title="detailModalTitle + $t('SubAccount.Details')"
        :show.sync="showDetailModal"
        size="xl"
        :closeOnBackdrop="false"
      >
        <div class="modal-bodys">
          <div class="box-content">
            <div class="box-content-dashboard">
              <!-- 支出概览 -->
              <div class="box-content-card chart-wrapper">
                <!-- <h3>支出概览</h3> -->
                <!-- <canvas id="donutChart" width="280" height="280"></canvas> -->
                <MyChartDoughnut
                :chartData="subAccountDetails.merchant_spent"
                :total="subAccountDetails.total_spent"
                :showLegend="false"
                height="360px"
                chartTitleTop="0%"
                :seriesCenter="['50%','50%']"
                graphicSpentTextTop="45%"
                graphicSpentTotalTop="50%"
                ></MyChartDoughnut>
                <!-- <div class="total-spent">
                  总支出：<span id="totalSpent">$0.00</span>
                </div> -->
              </div>

              <!-- 统计数据 -->
              <div class="box-content-card">
                <!-- <h3>统计数据</h3> -->
                <div class="stats">
                  <div class="stat-item">
                    <div class="stat-label">{{ $t("Dashboard.CurrentBalance") }}</div>
                    <div class="stat-value" id="balance">${{ formatNum(subAccountDetails.balance) }}</div>
                  </div>

                  <div class="stat-item">
                    <div class="stat-label">{{ $t("Dashboard.ConsumptionInRecent24Hours") }}</div>
                    <div class="stat-value" id="spent24">${{ formatNum(subAccountDetails.spent24) }}</div>
                  </div>

                  <div class="stat-item">
                    <div class="stat-label">{{ $t("Dashboard.ActiveCards") }}</div>
                    <div class="stat-value" id="cardNum">{{ subAccountDetails.card_num }}</div>
                  </div>

                  <div class="stat-item">
                    <div class="stat-label">{{ $t("Dashboard.TotalCardBalance") }}</div>
                    <div class="stat-value" id="cardBalance">${{ formatNum(subAccountDetails.card_balance) }}</div>
                  </div>

                  <div class="stat-item">
                    <div class="stat-label">{{ $t("Dashboard.AuthTimes") }}</div>
                    <div class="stat-value" id="authNum">{{ subAccountDetails.auth_num }}</div>
                  </div>

                  <div class="stat-item">
                    <div class="stat-label">{{ $t("Dashboard.DeclineRate") }}</div>
                    <div class="stat-value" id="declineRate" :style="toPoint(subAccountDetails.decline_rate) > 0.2 ? 'color: red' : ''">{{ subAccountDetails.decline_rate }}
                        <el-tooltip placement="top" v-if="toPoint(subAccountDetails.decline_rate) > 0.2">
                        <div slot="content">
                            <div>{{ $t("Dashboard.DeclineRateTip") }}</div>
                        </div>
                        <i style="cursor:pointer" class="el-icon-warning" v-if="toPoint(subAccountDetails.decline_rate) >= 0.2"></i>
                        </el-tooltip>
                    </div>
                  </div>
                  
                </div>
                <div>
                    <ReportComponent :isSubAccount="true" :subUid="detailModalUserId"></ReportComponent>
                  </div>
              </div>
            </div>
          </div>
        </div>
        <template #footer>
          <CButton
            color=""
            style="background: #fff; border: 1px solid #e8e8e8"
            @click="staticCancel"
          >
            {{ $t("VirtualCard.StaticFeild.Close") }}
          </CButton>
        </template>
      </CModal>
    </div>
    <!-- 重置密码窗口 -->
    <el-dialog
      append-to-body
      :close-on-click-modal="false"
      custom-class="create-card-holder-dialog"
      width="28%"
      :title="$t('SubAccount.SubAccountResetPassword')"
      :visible.sync="dialogFormVisibleResetPw"
    >
    <div>
      <ResetPasswordComponent :subUid="suid" @handleDialog="handleDialogClose"></ResetPasswordComponent>
    </div>
    </el-dialog>
    <!-- 修改标签窗口 -->
        <div>
            <el-dialog
                :close-on-click-modal="false"
                :show-close="false"
                width="30%"
                :title="$t('VirtualCard.Modifylabel')"
                :visible.sync="showTagDialog"
            >
                <div class="card-info-box">
                <div style="cursor: pointer">
                    <div class="icon-box">
                    <div class="tds">
                        <!-- <CIcon name="cib-visa" /> -->

                        <!-- <div>{{ alias }}</div> -->
                        <div class="visa-box" style="margin-bottom: 1rem">
                        <div style="">{{ tag_userName }}</div>
                        </div>
                    </div>
                    </div>
                </div>
                </div>
                <div style="margin-bottom: 1rem">
                <el-input type="text" v-model="tagTag" />
                </div>
                <span slot="footer" class="dialog-footer">
                <el-button @click="dialogClose">{{
                    $t("VirtualCard.Cancel")
                }}</el-button>
                <el-button
                    type=""
                    style="background: #00bea4; color: #fff"
                    @click="dialogTagConfirm"
                    >{{ $t("VirtualCard.Confirm") }}</el-button
                >
                </span>
            </el-dialog>
        </div>
  </div>
</template>
<script>
import {
  getSubAccountLists,
  getCreateSubAccountInfo,
  createSubAccount,
  rechargeSubAccount,
  freezeSubAccount,
  getSubAccountDetails,
  updateSubAccountTag
} from "@/api/http.js";
import MyChartDoughnut from "../../components/MyChartDoughnut.vue";
import ResetPasswordComponent from '../../components/ResetPasswordComponent.vue'
import ReportComponent from '../../components/ReportComponent.vue'
export default {
  props: {
    useSelect: {
      type: Boolean,
    },
  },
  components: { MyChartDoughnut, ResetPasswordComponent, ReportComponent },
  data() {
    // const validateNumber = (rule, value, callback) => {
    //     console.log(rule)
    //     if (!/^\d*$/.test(value)) {
    //         callback(new Error('Invalid'));
    //     } else {
    //         callback();
    //     }
    // };
    const validateNumber = (rule, value, callback) => {
      console.log(rule);
      // 允许英文和数字
      if (!/^[a-zA-Z0-9]*$/.test(value)) {
        callback(new Error("Invalid"));
      } else {
        callback();
      }
    };
    return {
      dialogFormVisible: false,
      page_total: 0,
      page: 1,
      page_size: 10,
      items: [
        // {
        //   UserName: "2250247655@qq.com",
        //   Tag: "Test",
        //   AccountBalance: "20",
        //   CardBalance: "10",
        //   CardSpent: "5",
        //   CardNum: 5,
        //   Status: "Active",
        //   UserId: "1222",
        //   Transfer: 10,
        //   Topup: 5,
        //   Refund: 0,
        //   Reconcile: 12,
        //   TopupFee: 10,
        //   IssueFee: 0,
        //   TransactionFee: 0,
        //   DeclineFee: 0,
        //   RefundFee: 0,
        // },
        // {
        //   UserName: "gokukobe@hotmail.com",
        //   Tag: "Test",
        //   AccountBalance: "120",
        //   CardBalance: "30",
        //   CardSpent: "10",
        //   CardNum: 20,
        //   Status: "Active",
        //   UserId: "1322",
        //   Transfer: 12,
        //   Topup: 15,
        //   Refund: 0,
        //   Reconcile: 12,
        //   TopupFee: 1,
        //   IssueFee: 0,
        //   TransactionFee: 0,
        //   DeclineFee: 0,
        //   RefundFee: 0,
        // },
        // {
        //   UserName: "czp2250@gmail.com",
        //   Tag: "Test",
        //   AccountBalance: "50",
        //   CardBalance: "20",
        //   CardSpent: "8",
        //   CardNum: 30,
        //   Status: "Suspended",
        //   UserId: "1522",
        //   Transfer: 1,
        //   Topup: 0,
        //   Refund: 10,
        //   Reconcile: 6,
        //   TopupFee: 0,
        //   IssueFee: 0,
        //   TransactionFee: 0,
        //   DeclineFee: 0,
        //   RefundFee: 0,
        // },
      ],
      subAccountForm: {
        email: "",
        tag: "",
      },
      subAccountRulesForm: {
        email: [
          {
            required: true,
            message:
              this.$t("SubAccount.SubAccountEmail") +
              this.$t("VirtualCard.CardHolderPage.IsRequired"),
            trigger: "blur",
          },
        ],
      },
      remain_sub_num: 0,
      dialogReChargeVisible: false,
      subAccountRechargeForm: {
        recharge_amount: null,
      },
      suid: "", // 子账户ID
      isRecharge: false,
      sUserName: "",
      dialogSuspendVisible: false,
      clickCommand: "",
      showDetailModal: false,
      detailModalTitle: '',
      detailModalUserId: '',
      currentListIndex: 0,
      subAccountDetails: {
        balance: 0,
        deposit: 0,
        spent24: 0,
        cards24: 0,
        total_spent: 0,
        decline_rate: "0%",
        card_balance: 0,
        card_num: 0,
        auth_num: 0,
        guarantee: 0,
        // 支出概览
        merchant_spent: [
        //   {
        //     name: "Card Spent",
        //     value: 0,
        //   },
        //   {
        //     name: "Issue Fee",
        //     value: 7,
        //   },
        //   {
        //     name: "Topup Fee",
        //     value: 2.12,
        //   },
        //   {
        //     name: "Decline Fee",
        //     value: 0,
        //   },
        //   {
        //     name: "Transaction Fee",
        //     value: 6,
        //   },
        //   {
        //     name: "Refund Fee",
        //     value: 2,
        //   },
        ],
      }, // 子账户详情数据
      subAccountRechargeRulesForm: {
        recharge_amount: [
          {
            required: true,
            message: this.$t("BankWithdrawal.InvalidAmount"),
            trigger: "blur",
          },
          {
            validator: (rule, value, callback) => {
              if (value === "" || value === null || value === undefined) {
                callback();
                return;
              }

              // 只允许正数（整数或小数）
              const reg = /^(?:[1-9]\d*|0)?(?:\.\d+)?$/;

              if (!reg.test(value) || Number(value) <= 0) {
                callback(new Error(this.$t("BankWithdrawal.InvalidAmount")));
              } else {
                callback();
              }
            },
            trigger: "blur",
          },
        ],
      },
      // pickerOptions: {
      //     // disabledDate(time) {
      //     // // 禁用1995年1月1日之前的日期
      //     // return time.getTime() < new Date('1995-01-01').getTime();
      //     // },
      //     // 设置默认显示的日期为1995-01-01
      //     defaultTime: '1995-01-01'
      // },
      errorCallBack: "",
      countryOption: ["UD", "EN"],
      billingAdrOptions: [
        "CN",
        "HK",
        "UK",
        "MO",
        "TW",
        "AF",
        "AX",
        "AL",
        "DZ",
        "AS",
        "AD",
        "AO",
        "AI",
        "AQ",
        "AG",
        "AR",
        "AM",
        "AW",
        "AU",
        "AT",
        "AZ",
        "BS",
        "BH",
        "BD",
        "BB",
        "BY",
        "BE",
        "BZ",
        "BJ",
        "BM",
        "BT",
        "BO",
        "BQ",
        "BA",
        "BW",
        "BV",
        "BR",
        "IO",
        "BN",
        "BG",
        "BF",
        "BI",
        "CV",
        "KH",
        "CM",
        "CA",
        "KY",
        "CF",
        "TD",
        "CL",
        "CX",
        "CC",
        "CO",
        "KM",
        "CG",
        "CD",
        "CK",
        "CR",
        "CI",
        "HR",
        "CU",
        "CW",
        "CY",
        "CZ",
        "DK",
        "DJ",
        "DM",
        "DO",
        "EC",
        "EG",
        "SV",
        "GQ",
        "ER",
        "EE",
        "SZ",
        "ET",
        "FK",
        "FO",
        "FJ",
        "FI",
        "FR",
        "GF",
        "PF",
        "TF",
        "GA",
        "GM",
        "GE",
        "DE",
        "GH",
        "GI",
        "GR",
        "GL",
        "GD",
        "GP",
        "GU",
        "GT",
        "GG",
        "GN",
        "GW",
        "GY",
        "HT",
        "HM",
        "VA",
        "HN",
        "HU",
        "IS",
        "IN",
        "ID",
        "IR",
        "IQ",
        "IE",
        "IM",
        "IL",
        "IT",
        "JM",
        "JP",
        "JE",
        "JO",
        "KZ",
        "KE",
        "KI",
        "KP",
        "KR",
        "KW",
        "KG",
        "LA",
        "LV",
        "LB",
        "LS",
        "LR",
        "LY",
        "LI",
        "LT",
        "LU",
        "MG",
        "MW",
        "MY",
        "MV",
        "ML",
        "MT",
        "MH",
        "MQ",
        "MR",
        "MU",
        "YT",
        "MX",
        "FM",
        "MD",
        "MC",
        "MN",
        "ME",
        "MS",
        "MA",
        "MZ",
        "MM",
        "NA",
        "NR",
        "NP",
        "NL",
        "NC",
        "NZ",
        "NI",
        "NE",
        "NG",
        "NU",
        "NF",
        "MK",
        "MP",
        "NO",
        "OM",
        "PK",
        "PW",
        "PS",
        "PA",
        "PG",
        "PY",
        "PE",
        "PH",
        "PN",
        "PL",
        "PT",
        "PR",
        "QA",
        "RE",
        "RO",
        "RU",
        "RW",
        "BL",
        "SH",
        "KN",
        "LC",
        "MF",
        "PM",
        "VC",
        "WS",
        "SM",
        "ST",
        "SA",
        "SN",
        "RS",
        "SC",
        "SL",
        "SG",
        "SX",
        "SK",
        "SI",
        "SB",
        "SO",
        "ZA",
        "GS",
        "SS",
        "ES",
        "LK",
        "SD",
        "SR",
        "SJ",
        "SE",
        "CH",
        "SY",
        "TJ",
        "TZ",
        "TH",
        "TL",
        "TG",
        "TK",
        "TO",
        "TT",
        "TN",
        "TR",
        "TM",
        "TC",
        "TV",
        "UG",
        "UA",
        "AE",
        "GB",
        "UM",
        "US",
        "UY",
        "UZ",
        "VU",
        "VE",
        "VN",
        "VG",
        "VI",
        "WF",
        "EH",
        "YE",
        "ZM",
        "ZW",
      ],
      dialogFormVisibleResetPw: false,
      showTagDialog: false,
      tagTag: '',
      tag_userName: '',
      tag_sub_id: ''
    };
  },
  computed: {
    sortBillingAdrOptions() {
      return this.billingAdrOptions.sort();
    },
    staticInfoData() {
      // if(this.items.length === 0) {
      //     return null;
      // } else {
      //     return this.items[this.currentListIndex];
      // }
      return this.subAccountDetails;
    },
    getLa() {
      // return localStorage.getItem("lang")
      let la = this.$i18n.locale
      if(la == 'en') {
        return 'en-US'
      }else {
        return this.$i18n.locale
      }
    }
  },
  created() {
    this.initSubAccountList();
  },
  methods: {
    // 状态命名
    handleCommand(command, row) {
      console.log("command", command);
      this.clickCommand = command;
      // 打开转入资金窗口
      if (command === "recharge") {
        this.suid = row.UserId;
        this.isRecharge = true;
        this.dialogReChargeVisible = true;
      } else if (command === "refund") {
        this.isRecharge = false;
        this.suid = row.UserId;
        this.dialogReChargeVisible = true;
      } else if (command === "suspend") {
        this.suid = row.UserId;
        this.dialogSuspendVisible = true;
      } else if (command === "active") {
        this.suid = row.UserId;
        this.dialogSuspendVisible = true;
      } else if(command === 'reset_password') {
        this.dialogFormVisibleResetPw = true
        this.suid = row.UserId
      }
      this.sUserName = row.UserName;
    },
    handleDialogClose() {
      this.dialogFormVisibleResetPw = false
    },
    staticCancel() {
      this.showDetailModal = false;
    },
    // 打開標簽編輯窗口
    showEditTagDialog(val) {
      this.showTagDialog = true;
      this.tagTag = val.row.Tag;
      this.tag_userName = val.row.UserName;
      this.tag_sub_id = val.row.UserId
    },
    // 取消標簽窗口
    dialogClose() {
      this.showTagDialog = false;
      this.tagTag = '';
    },
    // 確認更新標簽
    dialogTagConfirm() {
      let data = {
        type: "modify_subaccount_tag",
        uid: window.localStorage.getItem("uid"),
        tag: this.tagTag,
        sub_uid: this.tag_sub_id
      };
      updateSubAccountTag(data).then((res) => {
        if (res.code == 200) {
          this.initSubAccountList();
          this.$message.success(res.message);
          this.showTagDialog = false;
        } else {
          this.$message.error(res.message);
          this.showTagDialog = true;
        }
      });
    },
    // copy
    getCopy(data) {
      let input = document.createElement("input"); // js创建一个input输入框
      input.value = data; // 将需要复制的文本赋值到创建的input输入框中
      document.body.appendChild(input); // 将输入框暂时创建到实例里面
      input.select(); // 选中输入框中的内容
      document.execCommand("Copy"); // 执行复制操作
      document.body.removeChild(input); // 最后删除实例中临时创建的input输入框，完成复制操作
      this.$message({
        type: "success",
        message: "Copied",
      });
    },
    // 百分比轉爲小數
    toPoint(percent) {
      let v = percent || "0%"
      var fnum = v.replace("%", "");
        console.log('fnum==>', fnum)
      fnum = fnum / 100;
      return fnum;
    },
    formatNum(value) {
      if (!value && value !== 0) return 0;

      let str = value.toString();
      let reg =
        str.indexOf(".") > -1 ? /(\d)(?=(\d{3})+\.)/g : /(\d)(?=(?:\d{3})+$)/g;
      return str.replace(reg, "$1,");
    },
    // 小数转百分比显示
    toPercent(point) {
      if (point == 0) {
        return 0;
      }
      var str = Number(point * 100).toFixed(2);
      str += "%";
      return str;
    },
    // 金额每3位逗号隔开
    formatNum(value) {
      if (!value && value !== 0) return 0;

      let str = value.toString();
      let reg =
        str.indexOf(".") > -1 ? /(\d)(?=(\d{3})+\.)/g : /(\d)(?=(?:\d{3})+$)/g;
      return str.replace(reg, "$1,");
    },
    // 状态颜色
    customStatusType(row) {
      if (row.Status === "Active") {
        return "success";
      } else if (row.Status === "Suspended") {
        return "info";
      } else {
        return "";
      }
    },
    // 查看详情
    lookDetail(row, index) {
      this.showDetailModal = true;
      this.currentListIndex = index;
      this.detailModalTitle = row?.UserName
      this.detailModalUserId = (row?.UserId)
      this.initSubAccountDetail(row?.UserId)
    },
    // 冻结或者激活提示
    customSuspendAndActiveTip() {
      if (this.clickCommand === "suspend") {
        return this.$t("SubAccount.SubAccountSuspendConfirmation");
      } else if (this.clickCommand === "active") {
        return this.$t("SubAccount.SubAccountActiveConfirmation");
      }
    },
    // 获取子账户数据
    initSubAccountList() {
      const data = {
        type: "get_subaccount_list",
        uid: window.localStorage.getItem("uid"),
        page: this.page,
        page_size: this.page_size,
      };
      getSubAccountLists(data).then((res) => {
        if (res.code == 200) {
          this.items = res.data.data;
          this.page_total = Number(res.data.size);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 获取子账户详情
    initSubAccountDetail(suid) {
      const data = {
        type: "get_subaccount_details",
        uid: window.localStorage.getItem("uid"),
        suid: suid,
      };
      this.subAccountDetails.merchant_spent = []
      getSubAccountDetails(data).then((res) => {
        if (res.code == 200) {
        //   this.subAccountDetails = res.data;
          this.subAccountDetails.balance = res.data?.balance // 总余额
          this.subAccountDetails.deposit = res.data?.deposit
          this.subAccountDetails.spent24 = res.data?.spent24 // 近24小时消费
          this.subAccountDetails.cards24 = res.data?.cards24
          this.subAccountDetails.total_spent = res.data?.total_spent // 支出总额
          this.subAccountDetails.cards24 = res.data?.decline_rate // 授权失败率
          this.subAccountDetails.card_balance = res.data?.card_balance // 卡余额总值
          this.subAccountDetails.card_num = res.data?.card_num // active卡数
          this.subAccountDetails.auth_num = res.data?.auth_num // 授权数
          this.subAccountDetails.guarantee = res.data?.guarantee
          
          // 图表数据
          if(res.data.merchant_spent.length != 0) {
              res.data.merchant_spent.forEach((item) => {
                this.subAccountDetails.merchant_spent.push({
                name: item.name,
                value: item.amt,
                });
            });
          }
          
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 获取子账户信息
    initCreateSubAccountInfo() {
      const data = {
        type: "get_create_subaccount_info",
        uid: window.localStorage.getItem("uid"),
      };
      getCreateSubAccountInfo(data).then((res) => {
        if (res.code == 200) {
          this.remain_sub_num = res.data?.remain_sub_num || 0;
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 创建子账户
    initCreateSubAccount(formName) {
      const data = {
        type: "create_subaccount",
        uid: window.localStorage.getItem("uid"),
        ...this.subAccountForm,
      };
      createSubAccount(data).then((res) => {
        if (res.code == 200) {
          // 重新请求列表数据
          this.initSubAccountList();
          // 重置表单数据
          this.$refs[formName].resetFields();
          // 关闭窗口
          this.dialogFormVisible = false;
          // 跳转到开户记录页
          this.$router.push("/account/history");
          this.$message.success(res.message);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 当前页码改变
    handerPage(page) {
      console.log(page);
      this.page = page;
      this.initSubAccountList();
      // this.initCardHolderList()
    },
    // 选择持卡人
    handleSelectCardHolder(item) {
      this.$emit("onSelected", item);
    },
    // 当前总页数改变
    handleSizeChange(size) {
      console.log(size);
    },
    // 打开创建子账户窗口
    openCreateSubAccountDialog() {
      this.dialogFormVisible = true;
      this.initCreateSubAccountInfo();
    },
    // 取消关闭窗口
    cancelCreate(formName) {
      this.$refs[formName].resetFields();
      this.dialogFormVisible = false;
    },
    // 取消转入资金
    cancelRecharge(formName) {
      this.$refs[formName].resetFields();
      this.dialogReChargeVisible = false;
      this.suid = "";
      this.sUserName = "";
    },
    // 冻结子账户
    submitSuspend(freeze) {
      const data = {
        type: "freeze_subaccount",
        uid: window.localStorage.getItem("uid"),
        freeze: freeze, // 0为冻结、1为解冻
        suid: this.suid, // 子账户ID
      };
      freezeSubAccount(data).then((res) => {
        if (res.code == 200) {
          // 重新请求列表数据
          this.initSubAccountList();
          // 关闭窗口
          this.dialogSuspendVisible = false;
          this.$message.success(res.message);
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 提交转入资金
    initSubAccountRecharge(formName, inout) {
      const data = {
        type: "subaccount_transfer",
        uid: window.localStorage.getItem("uid"),
        inout: inout, // 1为转入、0为转出
        suid: this.suid, // 子账户ID
        amount: this.subAccountRechargeForm.recharge_amount,
      };
      rechargeSubAccount(data).then((res) => {
        if (res.code == 200) {
          // 重新请求列表数据
          this.initSubAccountList();
          // 重置表单数据
          this.$refs[formName].resetFields();
          // 关闭窗口
          this.dialogReChargeVisible = false;
          this.$message.success(res.message);
          this.suid = "";
        } else {
          this.$message.error(res.message);
        }
      });
    },
    // 验证提交转入资金
    submitRechargeForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          // this.initCreateSubAccount(formName)
          console.log("success");
          if (this.isRecharge) {
            // 转入
            this.initSubAccountRecharge(formName, 1);
          } else {
            // 转出
            this.initSubAccountRecharge(formName, 0);
          }
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
    // 验证表单
    submitCardHolderForm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          this.initCreateSubAccount(formName);
          console.log("success");
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    },
  },
};
</script>
<style>
.create-card-holder-dialog {
  border-radius: 10px;
}
</style>
<style scoped>
.tag-box {
  display: flex;
  justify-content: space-between;
  align-items: center;
}
.subaccount-columnText-bold {
  font-weight: bold;
  font-size: 16px;
}
/* 详情样式 */
.box-content-dashboard {
  display: grid;
  grid-template-columns: 380px 1fr;
  gap: 24px;
}

.box-content-card {
  background: #fff;
  border-radius: 16px;
  padding: 20px;
  box-shadow: 0 6px 20px rgba(0, 0, 0, 0.06);
}

.box-content-card h3 {
  margin: 0 0 16px;
  font-size: 16px;
  color: #333;
}

/* 统计卡片 */
.stats {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 16px;
}

.stat-item {
  padding: 16px;
  border-radius: 12px;
  background: linear-gradient(145deg, #f9fafc, #ffffff);
  border: 1px solid #eef1f6;
}

.stat-label {
  font-size: 13px;
  color: #888;
  margin-bottom: 6px;
}

.stat-value {
  font-size: 23px;
  font-weight: 700;
  color: #3773CD;
}

/* 圆环图区域 */
.chart-wrapper {
  display: flex;
  flex-direction: column;
  align-items: center;
}

.total-spent {
  margin-top: 12px;
  font-size: 14px;
  color: #666;
}

.total-spent span {
  font-size: 20px;
  font-weight: 600;
  color: #222;
}

@media (max-width: 1000px) {
  .box-content-dashboard {
    grid-template-columns: 1fr;
  }

  .stats {
    grid-template-columns: repeat(2, 1fr);
  }
}
/* end */
.recharge-dialog {
  display: flex;
  align-items: center;
  justify-content: flex-end;
}
.create-sub-account-tip {
  margin: 0;
  padding-bottom: 5px;
  font-size: 12px;
}
.create-sub-account-tip:last-child {
  padding-bottom: 0;
}
.sub-account-class {
  padding-left: 2.5rem;
  overflow: hidden;
}
.ch-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 20px;
}
.create-holder-btn {
  background-color: #00bea4;
  color: #fff;
}
.mgr-16 {
  margin-bottom: 16px;
}
::v-deep .el-input__inner {
  border-radius: 4px !important;
  /* border: 0; */
  /* padding-left: 0; */
  /* padding-right: 0; */
  /* box-shadow: none !important; */
  /* border-bottom: 1px solid #d9d9d9; */
  vertical-align: middle;
  border-color: #d8dbe0 !important;
  /* padding: 6px 12px !important; */
  /* line-height: 1.5 !important; */
  background-clip: padding-box;
  padding-top: 16.5px !important;
  padding-bottom: 16.5px !important;
}
::v-deep .el-form-item__label {
  line-height: normal;
  margin: 0;
  font-weight: bold;
  margin-bottom: 8px;
}
</style>